<div class="sk-betslip-header-container">
    <div class="sk-betslip-circle"></div>
    <div class="sk-betslip-info">
        <div class="sk-betslip-info1 sk-h-12 sk-b-rad8"></div>
        <div class="sk-betslip-info2 sk-h-12 sk-b-rad8"></div>
    </div>
</div>
<div class="sk-minigames-grid">
    @for (i of [0, 1, 2, 3, 4, 5]; track i) {
        <div class="sk-mini-grids sk-b-rad4"></div>
    }
</div>
